import { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";
import FormData from "form-data";
import axios from "axios";

const FIELD_MAP = {
  0: [["documentType", "Document Type"], ['requestId', 'Request ID'],],

  1: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["bankName", "Bank Name"],
    ["fromDate", "From Date"],
    ["toDate", "To Date"],
    ["accountNo", "Account Number"],
    ["holderName", "Holder Name"],
    ["ifscCode", "IFSC Code"],
    ["pageCount", "Page Count"],
    ["is10kAvailable", "10K Available"],
    ["islogoPresent", "Logo Present"],
    ['requestId', 'Request ID'],
  ],

  2: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["panNumber", "PAN Number"],
    ["nameOfEmployee", "Name of Employee"],
    ["periodFrom", "Period From"],
    ["periodTo", "Period To"],
    ["assessmentYear", "Assessment Year"],
    ["employeeAddress", "Employee Address"],
    ["pageCount", "Page Count"],
    ["isLatest", "Is Latest"],
    ["grosstotalIncome", "Gross total Income"],
    ['requestId', 'Request ID'],
  ],

  3: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["panNumber", "PAN Number"],
    ["assessmentYear", "Assessment Year"],
    ["name", "Name"],
    ["address", "Address"],
    ["acknowledgementNumber", "Acknowledgement Number"],
    ["totalIncome", "Total Income"],
    ["pageCount", "Page Count"],
    ['requestId', 'Request ID'],
  ],

  4: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["dpId", "DP ID"],
    ["clientId", "Client ID"],
    ["brokerName", "Broker Name"],
    ["name", "Name"],
    ["billDateTo", "Bill Date To"],
    ["dpStatus", "DP Status"],
    ["type", "Type"],
    ["subtype", "Subtype"],
    ["bsda", "BSDA"],
    ["category", "Category"],
    ["address", "Address"],
    ["pageCount", "Page Count"],
    ["is5kAvailable", "5K Available"],
    ["isLatest", "Is Latest"],
    ["panNumber", "Pan Number"],
    ['requestId', 'Request ID'],
  ],

  5: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["accountNo", "Account Number"],
    ["ifscCode", "IFSC Code"],
    ["holderName", "Holder Name"],
    ["pageCount", "Page Count"],
    ["islogoPresent", "Logo Present"],
    ["bankName", "Bank Name"],
    ['requestId', 'Request ID'],
  ],

  6: [
    ["documentType", "Document Type"],
    ["documentName", "Document Name"],
    ["status", "Status"],
    ["applicantName", "Applicant Name"],
    ["monthYear", "Month Year"],
    ["accountNumber", "Account Number"],
    ["panNumber", "PAN Number"],
    ["pageCount", "Page Count"],
    ["isLatest", "Is Latest"],
    ["grosstotalIncome", "Gross total Income"],
    ['requestId', 'Request ID'],
  ],
};

// function DocTable({ data }) {
//   const fields = FIELD_MAP[data?.documentType] || [
//     ["documentType", "Unknown Type"],
//   ];
//   return (
//     <table className="table">
//       <tbody>
//         {fields.map(([key, label]) => (
//           <tr key={key}>
//             <th width="30%">{label}</th>
//             <td>
//               {key === "is10kAvailable"
//                 ? data[key] === 1
//                   ? "True"
//                   : "False"
//                 : String(data[key] ?? "-")}
//             </td>
//           </tr>
//         ))}

//         {"statuserrorMsg" in data && (
//           <tr>
//             <th>Status Message</th>
//             <td>{data.statuserrorMsg}</td>
//           </tr>
//         )}

//         {"isLatest" in data && (
//           <tr>
//             <th>Is Latest</th>
//             <td>{data.isLatest ? "Yes" : "No"}</td>
//           </tr>
//         )}

//         {"islatesterrorMsg" in data && (
//           <tr>
//             <th>Latest Error</th>
//             <td>{data.islatesterrorMsg || "-"}</td>
//           </tr>
//         )}

//         {"isEdited" in data && (
//           <>
//             <tr>
//               <th>Is Edited</th>
//               <td>{data.isEdited ? "Yes" : "No"}</td>
//             </tr>
//             <tr>
//               <th>Edited Reason</th>
//               <td>{data.editedReason || "-"}</td>
//             </tr>
//             <tr>
//               <th>Edited Error Message</th>
//               <td>{data.editederrorMsg || "-"}</td>
//             </tr>
//           </>
//         )}
//       </tbody>
//     </table>
//   );
// }
function DocTable({ data }) {
  if (!data || typeof data !== "object") {
    return <p>No data available</p>;
  }

  const formatLabel = (key) =>
    key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());

  const renderValue = (value) => {
    if (value === null || value === undefined) return "-";

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (Array.isArray(value)) {
      return value.length ? (
        <ul style={{ margin: 0, paddingLeft: "18px" }}>
          {value.map((item, i) => (
            <li key={i}>{renderValue(item)}</li>
          ))}
        </ul>
      ) : (
        "-"
      );
    }

    if (typeof value === "object") {
      return (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            background: "#f9fafb",
          }}
        >
          <tbody>
            {Object.entries(value).map(([k, v]) => (
              <tr key={k}>
                <th
                  style={{
                    textAlign: "left",
                    padding: "6px",
                    border: "1px solid #e5e7eb",
                    width: "35%",
                    background: "#f3f4f6",
                  }}
                >
                  {formatLabel(k)}
                </th>
                <td
                  style={{
                    padding: "6px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  {renderValue(v)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    return String(value);
  };

  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #e5e7eb",
      }}
    >
      <tbody>
        {Object.entries(data).map(([key, value]) => (
          <tr key={key}>
            <th
              style={{
                textAlign: "left",
                padding: "8px",
                border: "1px solid #e5e7eb",
                width: "30%",
                background: "#f3f4f6",
              }}
            >
              {formatLabel(key)}
            </th>
            <td
              style={{
                padding: "8px",
                border: "1px solid #e5e7eb",
              }}
            >
              {renderValue(value)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}


function DocGenAi() {
  const [cardData, setCardData] = useState(null);
  const [img, setImg] = useState(null);
  const [loading, setLoading] = useState(true);

  const onChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = function () {
      const base64String = reader.result
        .replace("data:", "")
        .replace(/^.+,/, "");
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData(null);

    // const data = new FormData();
    // data.append("ImageByte", img);

    // axios({
    //   method: "post",
    //   url: "https://8v8dut1sue.execute-api.ap-south-1.amazonaws.com/default/financialproof",
    //   headers: {
    //     "x-api-key": "HI0pE07nUA8zW0mzQ2OC97gKnU6WVixl27kisdc4",
    //     authorizationToken: "43ttM0fR6IJ8JWMA",
    //   },
    //   data: data,
    // })
    //   .then((response) => {
    //     setCardData(response.data);
    //     setLoading(true);
    //   })
    //   .catch((error) => {
    //     setLoading(true);
    //     alert("Something went wrong with server");
    //     console.error(error);
    //   });


    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "pFWRy1wKlu6Zf4x9ql5a363fVH3qDLr314p2HeQX");
    myHeaders.append("authorizationToken", "60w7in9d3FLb98p2");

    const formdata = new FormData();
    formdata.append("im", img)

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow"
    };

    fetch("https://o9esj4y6yi.execute-api.ap-south-1.amazonaws.com/default/bajaj-financial-proof?requestId=123", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCardData(result);
        setLoading(true);
      }
      )
      .catch((error) => console.error(error));

  };

  return (
    <div>
      <div className="container containerBoreder">
        <h2 className="pageTitle">Financial Proof</h2>
        <div className="row">
          <div className="col-4">
            <input type="file" onChange={onChange} />
          </div>
          {loading ? (
            <div className="col-4">
              <button className="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>
          ) : (
            <ReactBootStrap.Spinner animation="border" />
          )}
        </div>
        <br />
        {cardData && <DocTable data={cardData} />}
      </div>
    </div>
  );
}

export default DocGenAi;
